import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import InputForm from "../../../../components/input/input-form";
import { Modal } from "../../../../components/modal/modal";
import Button from "../../../../components/button/button";
import AgGridUtils from "../../../../utils/aggrid-utils";
import aggridUtils from "../../../../utils/aggrid-utils.js";

const ModalSelectLanes = ({ show, onClose, onConfirm, existingDevices }) => {
    const [lanes, setLanes] = useState([]);
    const [selected, setSelected] = useState([]);
    const gridRef = useRef(null);
    const API_KEEPER = import.meta.env.VITE_API_KEEPER;

    useEffect(() => {
        if (!show) return;

        const loadLanes = async () => {
            try {
                const res = await axios.get(
                    `${API_KEEPER}/alarm-rules/form-info/`
                );

                const raw = typeof res.data === "string"
                    ? JSON.parse(res.data)
                    : res.data;

                const options = raw?.options ?? {};
                const devicesNode = options.devices ?? [];

                const allDevices = Array.isArray(devicesNode)
                    ? devicesNode
                    : [];

                const filtered = allDevices.filter(d =>
                    !existingDevices.some(e => Number(e.id) === Number(d.id))
                );

                setLanes(filtered);
            } catch (err) {
                console.error("Erro ao carregar câmeras: ", err);
            }
        };

        loadLanes();
    }, [show, API_KEEPER]);

    const columnDefs = [
        { headerName: "Dispositivos", valueGetter: (params) => params.data?.text || "-", flex: 1 }
    ];

    const CustomFloatingFilter = (props) => {
        const [filterName, setFilterName] = useState("");

        const handleChange = (e) => {
            const value = e.target.value;
            setFilterName(value);

            props.parentFilterInstance((inst) => {
                inst.onFloatingFilterChanged("contains", value);
            });
        };
        return (
            <div className="bg-white ">
                <InputForm 
                    label="Procurar..."
                    type="text"
                    value={filterName}
                    onChange={handleChange}
                />
            </div>
        );
    };

    const defaultColDef = {
        sortable:true,
        resizable: true,
        floatingFilter: true,
        filter: "agTextColumnFilter",
        filterParams: aggridUtils.filterParams,
        floatingFilterComponent: CustomFloatingFilter,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        suppressHeaderContextMenu: true,
        suppressFloatingFilterButton: true,
    };

    const handleSelectionChanged = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        setSelected(selectedRows);
    };

    const handleConfirm = () => {
        onConfirm(selected);
        onClose();
    };

    return (
        <Modal
            open={show}
            setOpen={(value) => { if (!value) onClose();}}
            title="Seleção de câmeras"
            className="w-full max-w-2xl"
        >
            <Modal.Body>
                <div className="ag-theme-quartz" style={{ height: "calc(60vh)" }}>
                    <AgGridReact 
                        ref={gridRef}
                        rowData={lanes}
                        columnDefs={columnDefs}
                        rowSelection={{
                            mode: "multiRow",
                            enableSelectionWithoutKeys: true,
                            enableClickSelection: true,
                        }}
                        animateRows={false}
                        suppressCellFocus={true}
                        suppressHeaderFocus={true}
                        defaultColDef={defaultColDef}
                        onSelectionChanged={handleSelectionChanged}
                        overlayNoRowsTemplate="Nenhum dispositivo encontrado"
                        gridOptions={{ localeText: AgGridUtils.localization() }}
                        theme={AgGridUtils.generalTheme()}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="flex w-full justify-end gap-2">
                    <Button target="primary" onClick={handleConfirm}>Ok</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalSelectLanes;